<template>
  <div
    class="spinner-border text-brand"
    role="status"
    style="font-size: 10px"
    v-bind:style="{ width: Size + 'px', height: Size + 'px' }"
  ></div>
</template>
<style lang="css">
.text-brand {
  color: #1a1818;
}
</style>

<script>
export default {
  name: "loadingSmall",
  props: {
    loading: Boolean,
    Size: {
      type: Number,
      default: 20,
    },
  },
};
</script>

<style>
</style>